import classNames from 'classnames';
import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import CollapseArrow from './collapse-arrow.svg';

import styles from './styles.scss';

export interface Props {
  className: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

const CollapseSection = ({ className, children, title, subtitle }: Props): JSX.Element => {
  const [collapseOpen, setOpen] = useState(false);

  const toggleOpen = (): void => {
    setOpen(!collapseOpen);
  };

  return (
    <div className={className}>
      <header className={styles.header} onClick={toggleOpen}>
        <h3 className={styles.title}>{title}</h3>
        <h4 className={styles.subtitle}>{subtitle}</h4>

        <CollapseArrow className={classNames(styles.collapseArrow, collapseOpen && styles.open)} />
      </header>

      <Collapse isOpened={collapseOpen}>
        <ul className={styles.valueList}>{children}</ul>
      </Collapse>
    </div>
  );
};

export default CollapseSection;
